import React, { useState, useEffect } from 'react';
import { 
  Search, 
  Filter, 
  Eye, 
  Edit, 
  Trash2, 
  ChevronDown,
  ChevronUp,
  Download,
  Printer,
  MoreVertical,
  Calendar,
  Clock,
  User,
  Package,
  DollarSign,
  CheckCircle,
  XCircle,
  Truck,
  ShoppingBag,
  ArrowUpDown
} from 'lucide-react';
import Layout from '../components/Layout';

const Orders = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');
  const [filterDate, setFilterDate] = useState('This Month');
  const [sortBy, setSortBy] = useState('newest');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const orders = [
    {
      id: '#H2025042501',
      customer: 'Ali Khan',
      email: 'ali@email.com',
      phone: '+91 98765 43210',
      amount: 1000,
      status: 'Delivered',
      date: '2024-04-25',
      time: '10:30 AM',
      items: 3,
      payment: 'UPI',
      address: '123, Main Street, Surat, Gujarat 395003',
      products: [
        { name: 'Majun Arad Khurma', quantity: 2, price: 250 },
        { name: 'Sharbat Faulad', quantity: 1, price: 500 }
      ]
    },
    {
      id: '#H2025042502',
      customer: 'Rahim Shahk',
      email: 'rahim@email.com',
      phone: '+91 98765 43211',
      amount: 1450,
      status: 'Out for Delivery',
      date: '2024-04-25',
      time: '02:15 PM',
      items: 2,
      payment: 'Card',
      address: '456, Park Avenue, Surat, Gujarat 395003',
      products: [
        { name: 'Habib-e-Sudanshan', quantity: 3, price: 180 },
        { name: 'Rogan Badam', quantity: 1, price: 450 }
      ]
    },
    {
      id: '#H2025042499',
      customer: 'Sana Pathan',
      email: 'sana@email.com',
      phone: '+91 98765 43212',
      amount: 320,
      status: 'Confirmed',
      date: '2024-04-24',
      time: '11:45 AM',
      items: 1,
      payment: 'Cash on Delivery',
      address: '789, Lake View, Surat, Gujarat 395003',
      products: [
        { name: 'Khamira Abresham', quantity: 1, price: 320 }
      ]
    },
    {
      id: '#H2025042488',
      customer: 'Imran Ansari',
      email: 'imran@email.com',
      phone: '+91 98765 43213',
      amount: 780,
      status: 'Delivered',
      date: '2024-04-24',
      time: '09:30 AM',
      items: 4,
      payment: 'Net Banking',
      address: '101, Green Road, Surat, Gujarat 395003',
      products: [
        { name: 'Majun Shabab', quantity: 2, price: 300 },
        { name: 'Sharbat Faulad', quantity: 1, price: 180 }
      ]
    },
    {
      id: '#H2025042487',
      customer: 'Faisal Memon',
      email: 'faisal@email.com',
      phone: '+91 98765 43214',
      amount: 1500,
      status: 'Canceled',
      date: '2024-04-23',
      time: '04:20 PM',
      items: 5,
      payment: 'UPI',
      address: '202, Garden Colony, Surat, Gujarat 395003',
      products: [
        { name: 'Majun Arad Khurma', quantity: 3, price: 250 },
        { name: 'Habib-e-Sudanshan', quantity: 2, price: 180 }
      ]
    },
    {
      id: '#H2025042486',
      customer: 'Zainab Ahmed',
      email: 'zainab@email.com',
      phone: '+91 98765 43215',
      amount: 650,
      status: 'Delivered',
      date: '2024-04-23',
      time: '12:10 PM',
      items: 2,
      payment: 'Card',
      address: '303, Hill View, Surat, Gujarat 395003',
      products: [
        { name: 'Rogan Badam', quantity: 1, price: 450 },
        { name: 'Khamira Abresham', quantity: 1, price: 200 }
      ]
    },
    {
      id: '#H2025042485',
      customer: 'Omar Farooq',
      email: 'omar@email.com',
      phone: '+91 98765 43216',
      amount: 1250,
      status: 'Out for Delivery',
      date: '2024-04-22',
      time: '08:45 AM',
      items: 3,
      payment: 'Cash on Delivery',
      address: '404, Ocean View, Surat, Gujarat 395003',
      products: [
        { name: 'Habib-e-Sudanshan', quantity: 4, price: 180 },
        { name: 'Sharbat Faulad', quantity: 2, price: 220 }
      ]
    },
    {
      id: '#H2025042484',
      customer: 'Fatima Sheikh',
      email: 'fatima@email.com',
      phone: '+91 98765 43217',
      amount: 480,
      status: 'Confirmed',
      date: '2024-04-22',
      time: '10:00 AM',
      items: 2,
      payment: 'UPI',
      address: '505, Green Valley, Surat, Gujarat 395003',
      products: [
        { name: 'Majun Arad Khurma', quantity: 1, price: 250 },
        { name: 'Rogan Badam', quantity: 1, price: 230 }
      ]
    },
    {
      id: '#H2025042483',
      customer: 'Hassan Ali',
      email: 'hassan@email.com',
      phone: '+91 98765 43218',
      amount: 920,
      status: 'Delivered',
      date: '2024-04-21',
      time: '05:30 PM',
      items: 3,
      payment: 'Card',
      address: '606, Lake Shore, Surat, Gujarat 395003',
      products: [
        { name: 'Majun Shabab', quantity: 2, price: 300 },
        { name: 'Khamira Abresham', quantity: 1, price: 320 }
      ]
    },
    {
      id: '#H2025042482',
      customer: 'Aisha Khan',
      email: 'aisha@email.com',
      phone: '+91 98765 43219',
      amount: 580,
      status: 'Canceled',
      date: '2024-04-21',
      time: '01:15 PM',
      items: 2,
      payment: 'Cash on Delivery',
      address: '707, Hill Top, Surat, Gujarat 395003',
      products: [
        { name: 'Habib-e-Sudanshan', quantity: 2, price: 180 },
        { name: 'Sharbat Faulad', quantity: 1, price: 220 }
      ]
    }
  ];

  const statusOptions = ['All', 'Confirmed', 'Out for Delivery', 'Delivered', 'Canceled'];
  const dateOptions = ['Today', 'This Week', 'This Month', 'This Year', 'Custom'];

  const getStatusBadge = (status) => {
    const classes = {
      'Delivered': 'badge-success',
      'Out for Delivery': 'badge-warning',
      'Confirmed': 'badge-info',
      'Canceled': 'badge-danger'
    };
    return classes[status] || 'badge-info';
  };

  const getStatusIcon = (status) => {
    const icons = {
      'Delivered': <CheckCircle size={16} />,
      'Out for Delivery': <Truck size={16} />,
      'Confirmed': <Clock size={16} />,
      'Canceled': <XCircle size={16} />
    };
    return icons[status] || <Clock size={16} />;
  };

  const getStatusColor = (status) => {
    const colors = {
      'Delivered': '#10B981',
      'Out for Delivery': '#F59E0B',
      'Confirmed': '#3B82F6',
      'Canceled': '#EF4444'
    };
    return colors[status] || '#6B7280';
  };

  // Filter orders
  const filteredOrders = orders.filter(order => {
    const matchesSearch = 
      order.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.customer.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.phone.includes(searchTerm);
    
    const matchesStatus = filterStatus === 'All' || order.status === filterStatus;
    
    return matchesSearch && matchesStatus;
  });

  // Sort orders
  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (sortBy === 'newest') {
      return new Date(b.date + ' ' + b.time) - new Date(a.date + ' ' + a.time);
    } else if (sortBy === 'oldest') {
      return new Date(a.date + ' ' + a.time) - new Date(b.date + ' ' + b.time);
    } else if (sortBy === 'highest') {
      return b.amount - a.amount;
    } else if (sortBy === 'lowest') {
      return a.amount - b.amount;
    }
    return 0;
  });

  // Stats
  const stats = {
    total: orders.length,
    delivered: orders.filter(o => o.status === 'Delivered').length,
    outForDelivery: orders.filter(o => o.status === 'Out for Delivery').length,
    confirmed: orders.filter(o => o.status === 'Confirmed').length,
    canceled: orders.filter(o => o.status === 'Canceled').length,
    totalRevenue: orders.reduce((sum, o) => sum + o.amount, 0)
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(sortedOrders.map(o => o.id));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectOrder = (id) => {
    if (selectedOrders.includes(id)) {
      setSelectedOrders(selectedOrders.filter(o => o.id !== id));
    } else {
      setSelectedOrders([...selectedOrders, id]);
    }
  };

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setShowOrderModal(true);
  };

  const handleStatusChange = (orderId, newStatus) => {
    // Update order status logic
    console.log(`Order ${orderId} status changed to ${newStatus}`);
  };

  return (
    <Layout>
      <div className="orders-page">
        {/* Page Header */}
        <div className="page-header">
          <div>
            <h1 className="page-title">Orders</h1>
            <p className="page-subtitle">Manage and track all customer orders</p>
          </div>
          <div className="page-actions">
            <button className="btn btn-outline btn-sm">
              <Download size={16} />
              Export
            </button>
            <button className="btn btn-outline btn-sm">
              <Printer size={16} />
              Print
            </button>
            <button className="btn btn-primary">
              <ShoppingBag size={18} />
              New Order
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="orders-stats">
          <div className="stat-item">
            <span className="stat-label">Total Orders</span>
            <span className="stat-value">{stats.total}</span>
            <span className="stat-change up">+12%</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Revenue</span>
            <span className="stat-value">₹{stats.totalRevenue.toLocaleString()}</span>
            <span className="stat-change up">+18%</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Delivered</span>
            <span className="stat-value">{stats.delivered}</span>
            <span className="stat-change up">+8%</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Pending</span>
            <span className="stat-value">{stats.outForDelivery + stats.confirmed}</span>
            <span className="stat-change down">-3%</span>
          </div>
        </div>

        {/* Filters */}
        <div className="orders-filters card">
          <div className="filter-row">
            <div className="filter-group">
              <div className="search-box">
                <Search size={18} className="search-icon" />
                <input
                  type="text"
                  placeholder="Search orders by ID, customer, email, or phone..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                {searchTerm && (
                  <button 
                    className="clear-search"
                    onClick={() => setSearchTerm('')}
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>

            <div className="filter-group">
              <select 
                className="filter-select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                {statusOptions.map(status => (
                  <option key={status} value={status}>
                    {status === 'All' ? 'All Status' : status}
                  </option>
                ))}
              </select>

              <select 
                className="filter-select"
                value={filterDate}
                onChange={(e) => setFilterDate(e.target.value)}
              >
                {dateOptions.map(date => (
                  <option key={date} value={date}>{date}</option>
                ))}
              </select>

              <select 
                className="filter-select"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="newest">Newest First</option>
                <option value="oldest">Oldest First</option>
                <option value="highest">Highest Amount</option>
                <option value="lowest">Lowest Amount</option>
              </select>
            </div>
          </div>
        </div>

        {/* Orders Table */}
        <div className="card orders-table-container">
          <div className="table-container">
            <table className="table orders-table">
              <thead>
                <tr>
                  <th style={{ width: '40px' }}>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      className="checkbox"
                    />
                  </th>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Date</th>
                  <th>Items</th>
                  <th>Amount</th>
                  <th>Payment</th>
                  <th>Status</th>
                  <th style={{ width: '120px' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedOrders.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="empty-state">
                      <div className="empty-state-content">
                        <span className="empty-icon">📦</span>
                        <h3>No orders found</h3>
                        <p>Try adjusting your search or filter criteria</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  sortedOrders.map((order) => (
                    <tr key={order.id} className="order-row">
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedOrders.includes(order.id)}
                          onChange={() => handleSelectOrder(order.id)}
                          className="checkbox"
                        />
                      </td>
                      <td>
                        <span 
                          className="order-id-link"
                          onClick={() => handleViewOrder(order)}
                        >
                          {order.id}
                        </span>
                      </td>
                      <td>
                        <div className="customer-info">
                          <div className="customer-avatar">
                            {order.customer.charAt(0)}
                          </div>
                          <div>
                            <div className="customer-name">{order.customer}</div>
                            <div className="customer-email">{order.email}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="date-info">
                          <div>{order.date}</div>
                          <div className="time-info">{order.time}</div>
                        </div>
                      </td>
                      <td>
                        <span className="items-count">{order.items}</span>
                      </td>
                      <td className="order-amount">
                        ₹{order.amount.toLocaleString()}
                      </td>
                      <td>
                        <span className="payment-method">{order.payment}</span>
                      </td>
                      <td>
                        <div className="status-select-wrapper">
                          <select
                            className={`status-select ${order.status.toLowerCase().replace(' ', '-')}`}
                            value={order.status}
                            onChange={(e) => handleStatusChange(order.id, e.target.value)}
                            style={{ borderColor: getStatusColor(order.status) }}
                          >
                            {statusOptions.filter(s => s !== 'All').map(status => (
                              <option key={status} value={status}>
                                {status}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button 
                            className="btn btn-sm btn-outline"
                            onClick={() => handleViewOrder(order)}
                            title="View Order"
                          >
                            <Eye size={16} />
                          </button>
                          <button 
                            className="btn btn-sm btn-outline"
                            title="Edit Order"
                          >
                            <Edit size={16} />
                          </button>
                          <button 
                            className="btn btn-sm btn-danger"
                            title="Delete Order"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Table Footer */}
          <div className="table-footer">
            <div className="table-info">
              {selectedOrders.length > 0 ? (
                <span>
                  {selectedOrders.length} orders selected
                  <button className="btn btn-sm btn-outline ml-sm">
                    Bulk Action <ChevronDown size={14} />
                  </button>
                </span>
              ) : (
                <span>Showing {sortedOrders.length} of {orders.length} orders</span>
              )}
            </div>
            <div className="pagination">
              <button className="btn btn-sm btn-outline">Previous</button>
              <button className="btn btn-sm btn-primary active">1</button>
              <button className="btn btn-sm btn-outline">2</button>
              <button className="btn btn-sm btn-outline">3</button>
              <span className="pagination-ellipsis">...</span>
              <button className="btn btn-sm btn-outline">10</button>
              <button className="btn btn-sm btn-outline">Next</button>
            </div>
          </div>
        </div>
      </div>

      {/* Order Detail Modal */}
      {showOrderModal && selectedOrder && (
        <div className="modal-overlay" onClick={() => setShowOrderModal(false)}>
          <div className="modal order-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <h2 className="modal-title">Order {selectedOrder.id}</h2>
                <p className="modal-subtitle">
                  Placed on {selectedOrder.date} at {selectedOrder.time}
                </p>
              </div>
              <button 
                className="modal-close"
                onClick={() => setShowOrderModal(false)}
              >
                ✕
              </button>
            </div>

            <div className="order-modal-content">
              {/* Order Status */}
              <div className="order-status-section">
                <div className="status-badge-large" style={{ background: getStatusColor(selectedOrder.status) + '20', color: getStatusColor(selectedOrder.status) }}>
                  {getStatusIcon(selectedOrder.status)}
                  {selectedOrder.status}
                </div>
                <div className="order-timeline">
                  <div className="timeline-step active">
                    <div className="step-dot" />
                    <div className="step-label">Confirmed</div>
                    <div className="step-time">25 Jun 2024, 10:30 PM</div>
                  </div>
                  <div className="timeline-step active">
                    <div className="step-dot" />
                    <div className="step-label">Out for Delivery</div>
                    <div className="step-time">25 Jun 2024, 04:15 PM</div>
                  </div>
                  <div className="timeline-step active">
                    <div className="step-dot" />
                    <div className="step-label">Delivered</div>
                    <div className="step-time">25 Jun 2024, 06:10 PM</div>
                  </div>
                </div>
              </div>

              {/* Order Details Grid */}
              <div className="order-details-grid">
                <div className="detail-section">
                  <h4>Customer Information</h4>
                  <div className="detail-item">
                    <User size={16} />
                    <span>{selectedOrder.customer}</span>
                  </div>
                  <div className="detail-item">
                    <span>📧</span>
                    <span>{selectedOrder.email}</span>
                  </div>
                  <div className="detail-item">
                    <span>📱</span>
                    <span>{selectedOrder.phone}</span>
                  </div>
                </div>

                <div className="detail-section">
                  <h4>Shipping Address</h4>
                  <div className="detail-item">
                    <span>📍</span>
                    <span>{selectedOrder.address}</span>
                  </div>
                </div>

                <div className="detail-section">
                  <h4>Payment Information</h4>
                  <div className="detail-item">
                    <span>💳</span>
                    <span>{selectedOrder.payment}</span>
                  </div>
                  <div className="detail-item">
                    <DollarSign size={16} />
                    <span>₹{selectedOrder.amount.toLocaleString()}</span>
                  </div>
                </div>
              </div>

              {/* Products List */}
              <div className="order-products">
                <h4>Order Items</h4>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrder.products.map((product, index) => (
                      <tr key={index}>
                        <td>{product.name}</td>
                        <td>{product.quantity}</td>
                        <td>₹{product.price}</td>
                        <td>₹{product.quantity * product.price}</td>
                      </tr>
                    ))}
                    <tr className="order-total-row">
                      <td colSpan="3" className="text-right"><strong>Total</strong></td>
                      <td><strong>₹{selectedOrder.amount.toLocaleString()}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="modal-actions">
                <button className="btn btn-outline" onClick={() => setShowOrderModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary">
                  <Printer size={16} />
                  Print Invoice
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Orders;